import React, { useEffect, useState } from 'react';
import {
    Route,
    Redirect
} from 'react-router-dom'
import { connect } from 'react-redux';
import Auth from "../../models/Auth";
import FetchResponses from "../../models/FetchResponses";
import settings from '../../settings';

const ValidateRouter = ({ component: Component, ...rest }) => {
    const [redirectUrl, setRedirectUrl] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        // Llamada a la API para obtener el módulo
        const getModule = () => {
            fetch(settings.backend.modules, {
                method: "GET",
                headers: settings.headers_auth(localStorage.getItem("session_token")),
            })
                .then(FetchResponses.processResponse)
                .then((response) => {
                    let module = settings.authenticated_admin_page;
                    if (response.modules && response.modules.length > 0) {
                        module = response.modules[0].url;
                    }
                    setRedirectUrl(module); // Actualizamos el estado con el módulo
                })
                .catch((err) => {
                    console.log("Error fetching modules", err);
                    setError(true); // Establecemos un error si la llamada falla
                });
        };

        getModule(); // Llamamos la función para obtener el módulo

    }, []); // Usamos un array vacío para que se ejecute solo una vez al montarse el componente

    
    return(
    <Route {...rest} render={(props) => {
        let render;
        let component = <Component {...props} />
        let redirectAdmin = <Redirect to={{
            pathname: redirectUrl,
            state: { from:redirectUrl }
        }} />
        let redirectUser = <Redirect to={{
            
            // pathname:localStorage.getItem('lastPath'),
            pathname:settings.authenticated_user_page,
            state: { from: props.location }
        }} />


        let isOnAdminPage = !!rest.adminPages.filter(word => word === rest.path).length;
        let isLoggedSharedPage =!!rest.loggedPages.filter(word => word === rest.path).length;
        
        if (!!Auth.isAdmin()) {
            render = (isLoggedSharedPage || isOnAdminPage) ? component : redirectAdmin;
        }
        else {

            // Se valida si la ruta es reservada para el usuario, y que el usuario no est
            ( rest.userPages.includes(rest.path) || rest.loggedPages.includes(rest.path) ) && localStorage.setItem('lastPath',rest.path);
            render = (isLoggedSharedPage || !isOnAdminPage) ? component : redirectUser;
        }
        return render ;

    }} />
)}

// Función que mapea el estado de Redux a las props del componente
const mapStateToProps = (state) => {
    return {
      modules: state.modulos, // Asegúrate de reemplazar con la propiedad correcta del estado
    };
  };
  
export default connect(mapStateToProps)(ValidateRouter);
  
